import { useEffect } from 'react';
import { type IFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type TextLayer } from '../../domain';

/**
 * T 键添加默认文本
 */
export const useTextLayerHotkey = (framework: IFramework) => {
    useEffect(() => {
        const { $t } = getLocaleStore();

        framework.service.hotkey.register({
            name: $t((v) => v.Text_NewText),
            win: 'T',
            mac: 'T',
            key: 'T',
            processors: [
                {
                    press: ['T'],
                    fn: () => {
                        const textLayer = framework.service.registration.getInstance<TextLayer>('TextLayer');
                        if (!textLayer) return;

                        textLayer.addDefaultContent();
                    },
                },
            ],
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
